
import {
  Article as NewsIcon,
  Dashboard as DashboardIcon,
  FlashOn as FlashIcon,
  Language as GlobalIcon,
  Widgets as WidgetIcon,
  Security as SecurityIcon,
  TrendingUp as TrendingIcon,
  CloudDone as CloudIcon,
  ArrowForward as ArrowIcon,
  Newspaper as NewspaperIcon,
  AdminPanelSettings as AdminIcon,
  MobileFriendly as MobileIcon,
  Payment as PaymentIcon,
  Gavel as LegalIcon,
  SmartToy as BotIcon,
  Search as SearchIcon,
  Palette
} from '@mui/icons-material';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';

const FeaturesElegant = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [visibleCards, setVisibleCards] = useState(new Set());
  const [hoveredCard, setHoveredCard] = useState(null);

  // RNS Haber Platformu Özellikleri
  const features = [
    {
      id: 1,
      icon: <WidgetIcon />,
      title: "70+ Widget Kütüphanesi",
      subtitle: "Görsel Tasarım ile Tasarlanan Sayfalar",
      description: "70'ten fazla özelleştirilebilir widget ile haber sitenizi istediğiniz gibi tasarlayın. Kod bilgisi gerektirmez, tamamen görsel arayüzle çalışır.",
      details: [
        "Ana manşet widget'ları (10+ varyasyon)",
        "Haber listesi bileşenleri (30+ stil)", 
        "Finans ve hava durumu widget'ları",
        "Sosyal medya entegrasyonu"
      ],
      color: "#1e40af",
      gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
      lightColor: "#dbeafe",
      pattern: "widgets"
    },
    // {
    //   id: 2,
    //   icon: <FlashIcon />,
    //   title: "Yüksek Performans",
    //   subtitle: "Hızlı Yükleme, Mutlu Okuyucular",
    //   description: "Modern teknolojilerle optimize edilmiş performans. Sayfa yükleme süreleri 1 saniyenin altında, SEO dostu yapı.",
    //   details: [
    //     "Ultra hızlı sayfa yükleme",
    //     "Otomatik görsel optimizasyonu",
    //     "Mobil optimizasyon",
    //     "SEO uyumlu yapı"
    //   ],
    //   color: "#dc2626",
    //   gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
    //   lightColor: "#fee2e2",
    //   pattern: "lightning"
    // },
    {
      id: 2,
      icon: <Palette />,
      title: "Tema & Tasarım Sistemi",
      subtitle: "Markanıza Özel Görünüm",
      description: "Renk paleti, font seçimi, logo yönetimi ve açık/koyu mod ile markanıza özgü profesyonel tasarım.",
      details: [
        "Renk paleti editörü",
        "Google Fonts entegrasyonu",
        "Açık/Koyu mod desteği",
        "Logo ve marka yönetimi"
      ],
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899 0%, #f472b6 100%)",
      lightColor: "#fce7f3",
      pattern: "palette"
    },
    {
      id: 3,
      icon: <AdminIcon />,
      title: "Güçlü Admin Panel",
      subtitle: "Her Şey Kontrolünüzde",
      description: "Kullanıcı dostu admin paneli ile haber yönetimi, kullanıcı rolleri, istatistikler ve tüm ayarları tek yerden yönetin.",
      details: [
        "Gelişmiş haber editörü",
        "Kullanıcı ve rol yönetimi",
        "Detaylı istatistik raporları",
        "Kategori ve etiket sistemi"
      ],
      color: "#059669",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
      lightColor: "#d1fae5",
      pattern: "admin"
    },
    {
      id: 4,
      icon: <PaymentIcon />,
      title: "Abonelik Sistemi",
      subtitle: "Gelir Modeli Oluşturun",
      description: "Entegre abonelik sistemi ile premium içerik sunun. Farklı paket seçenekleri ve güvenli ödeme altyapısı.",
      details: [
        "Esnek abonelik paketleri",
        "Premium içerik yönetimi",
        "Güvenli ödeme entegrasyonu",
        "Abone analiz raporları"
      ],
      color: "#7c3aed",
      gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
      lightColor: "#ede9fe",
      pattern: "payment"
    },
    {
      id: 5,
      icon: <LegalIcon />,
      title: "BİK Uyumluluğu",
      subtitle: "Resmi İlan Yayını",
      description: "Basın İlan Kurumu standartlarına tam uyumlu. Resmi ilan yönetimi, arşivleme ve raporlama özellikleri.",
      details: [
        "BİK standartlarına uyum",
        "Resmi ilan kategorilendirme",
        "Otomatik arşivleme sistemi",
        "Detaylı ilan raporları"
      ],
      color: "#ea580c",
      gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
      lightColor: "#fed7aa",
      pattern: "legal"
    },
    // {
    //   id: 6,
    //   icon: <MobileIcon />,
    //   title: "Mobil Uyumlu",
    //   subtitle: "Her Cihazda Mükemmel",
    //   description: "Mobil öncelikli tasarım yaklaşımı ile tüm cihazlarda kusursuz görünüm. Okuyucularınızın %60'ı mobilden gelir.",
    //   details: [
    //     "Responsive tasarım",
    //     "Touch-friendly arayüz",
    //     "Hızlı mobil yükleme",
    //     "Tüm ekran boyutlarına uyum"
    //   ],
    //   color: "#0891b2",
    //   gradient: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
    //   lightColor: "#cffafe",
    //   pattern: "mobile"
    // },
    {
      id: 7,
      icon: <BotIcon />,
      title: "Otomatik Ajans Botları",
      subtitle: "Haber Ajanslarından Otomatik Çekme",
      description: "Haber ajanslarından otomatik haber çekme sistemi. RSS feed okuyucu, ajans entegrasyonu ve otomatik içerik aktarımı.",
      details: [
        "RSS feed okuyucu ve yayıncı",
        "Haber ajansı entegrasyonu",
        "Otomatik içerik çekme",
        "Editör onay sistemi"
      ],
      color: "#6d107e",
      gradient: "linear-gradient(135deg, #6d107e 0%,rgb(193, 21, 223) 100%)",
      lightColor: "#6d107e3b",
      pattern: "bot"
    },
    // {
    //   id: 8,
    //   icon: <SearchIcon />,
    //   title: "SEO & Google Optimizasyonu",
    //   subtitle: "Arama Motorlarında Üst Sıralarda",
    //   description: "Gelişmiş SEO özellikleri ile Google'da üst sıralarda yer alın. Otomatik sitemap, meta tag yönetimi, Open Graph, Schema.org ve hız optimizasyonu. Organik trafik artışı garantisi.",
    //   details: [
    //     "Otomatik sitemap ve robots.txt",
    //     "Meta tag ve açıklama yönetimi",
    //     "Open Graph ve Twitter Card",
    //     "Schema.org yapısal veri"
    //   ],
    //   color: "#06b6d4",
    //   gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
    //   lightColor: "#cffafe",
    //   pattern: "seo"
    // }
  ];

  // Intersection observer with staggered animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setTimeout(() => {
              setVisibleCards(prev => new Set([...prev, index]));
            }, index * 150);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = document.querySelectorAll('[data-index]');
    cards.forEach(card => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <Box
    sx={{
      background: 'linear-gradient(53deg, #0f172a 0%, #1e3a8a 100%)',
    }}>
      <Box
    sx={{
      pt: { xs: 10, md: 16 },
      borderRadius: {xs : 0, md : '0 0 400px 0'},
    //   background: `
    //   linear-gradient(
    //     135deg,
    //     #ffffff 0%,
    //     #f8fafc 25%,
    //     #f1f5f9 50%,
    //     #e2e8f0 75%,
    //     #cbd5e1 100%
    //   )
    // `,
    backgroundColor:'#f1f6fb',
      color: '#1e293b',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
          radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%),
          radial-gradient(circle at 50% 50%, rgba(5, 150, 105, 0.03) 0%, transparent 50%)
        `,
        pointerEvents: 'none'
      }
    }}
  >
    <Container maxWidth="xl">
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 10, position: 'relative' }}>
        <Typography
          variant="overline"
          sx={{
            fontSize: '0.9rem',
            fontWeight: 900,
            letterSpacing: '0.1em',
            color: '#1e40af',
            mb: 2,
            display: 'block',
            textTransform: 'uppercase'
          }}
        >
          GÜÇLÜ ÖZELLİKLER
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2.8rem', md: '4rem' },
            fontWeight: 800,
            mb: 4,
            background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
            lineHeight: 1.1,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -8,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 80,
              height: 4,
              background: 'linear-gradient(90deg, #1e40af, #dc2626)',
              borderRadius: 2
            }
          }}
        >
          Profesyonel Haber Platformu
        </Typography>

        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: '1.3rem', md: '1.5rem' },
            color: '#64748b',
            maxWidth: 700,
            mx: 'auto',
            lineHeight: 1.6,
            fontWeight: 400
          }}
        >
        70+ widget, güçlü admin panel, abonelik sistemi ve BİK uyumluluğu ile 
        haber sitenizi yönetmek için ihtiyacınız olan her şey tek platformda
        </Typography>
      </Box>

      {/* Features Grid */}
      <Grid container spacing={4} sx={{ mb: 12 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={6} lg={4} key={feature.id}>
            <Paper
              data-index={index}
              elevation={0}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              sx={{
                p: 5,
                height: '100%',
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: 4,
                position: 'relative',
                cursor: 'pointer',
                opacity: visibleCards.has(index) ? 1 : 0,
                transform: visibleCards.has(index) 
                  ? 'translateY(0) scale(1)' 
                  : 'translateY(30px) scale(0.95)',
                transition: 'all 0.7s cubic-bezier(0.34, 1.56, 0.64, 1)',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  background: feature.gradient,
                  transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                  transformOrigin: 'left',
                  transition: 'transform 0.3s ease'
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: -50,
                  right: -50,
                  width: 100,
                  height: 100,
                  background: `radial-gradient(circle, ${feature.color}15 0%, transparent 70%)`,
                  borderRadius: '50%',
                  opacity: hoveredCard === index ? 1 : 0,
                  transition: 'opacity 0.4s ease',
                  pointerEvents: 'none'
                },
                '&:hover': {
                  transform: 'translateY(-8px) scale(1.02)',
                  boxShadow: `0 20px 40px ${feature.color}20, 0 10px 20px rgba(0, 0, 0, 0.1)`,
                  borderColor: feature.color,
                  '& .feature-icon-box': {
                    transform: 'scale(1.1) rotate(5deg)',
                    background: feature.gradient,
                    color: '#fff'
                  },
                  '& .feature-button': {
                    transform: 'translateX(8px)',
                    color: feature.color
                  }
                }
              }}
            >
              {/* Feature Icon */}
             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
             <Box
                className="feature-icon"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 4,
                  width: 80,
                  height: 80,
                  background: feature.lightColor,
                  borderRadius: 3,
                  color: feature.color,
                  position: 'relative',
                  transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 3,
                    padding: 2,
                    background: feature.gradient,
                    mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                    maskComposite: 'xor',
                    WebkitMaskComposite: 'xor',
                    opacity: hoveredCard === index ? 1 : 0,
                    transition: 'opacity 0.3s ease'
                  },
                }}
              >
                <Box
                  className="feature-icon-box"
                  sx={{ fontSize: '2.2rem', zIndex: 1 }}
                >
                  {feature.icon}
                </Box>
              </Box>

              <Box>
                {/* Content */}
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  color: '#1e293b',
                  fontSize: '1.5rem',
                  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                  transition: 'color 0.3s ease'
                }}
              >
                {feature.title}
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  mb: 3,
                  background: feature.gradient,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontSize: '1.1rem'
                }}
              >
                {feature.subtitle}
              </Typography>
              </Box>
             </Box>

              <Typography
                variant="body1"
                sx={{
                  color: '#64748b',
                  lineHeight: 1.7,
                  mb: 4,
                  fontSize: '1rem'
                }}
              >
                {feature.description}
              </Typography>

              {/* Feature List */}
              <Stack spacing={2} sx={{ mb: 5 }}>
                {feature.details.map((detail, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      opacity: visibleCards.has(index) ? 1 : 0,
                      transform: visibleCards.has(index) ? 'translateX(0)' : 'translateX(-20px)',
                      transition: `all 0.5s ease ${0.8 + idx * 0.1}s`
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: feature.gradient,
                        flexShrink: 0
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#475569',
                        fontSize: '0.95rem',
                        fontWeight: 500
                      }}
                    >
                      {detail}
                    </Typography>
                  </Box>
                ))}
              </Stack>

              {/* Button */}
              <Button
                className="feature-button"
                variant="text"
                endIcon={<ArrowIcon />}
                sx={{
                  color: '#64748b',
                  fontWeight: 600,
                  px: 0,
                  py: 1,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  transition: 'all 0.3s ease',
                  '& .MuiButton-endIcon': {
                    transition: 'transform 0.3s ease'
                  },
                  '&:hover': {
                    background: 'transparent',
                    '& .MuiButton-endIcon': {
                      transform: 'translateX(4px)'
                    }
                  }
                }}
              >
                Detayları İncele
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>

    {/* CSS Animations */}
    <style jsx global>{`
      @keyframes shimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }

      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }
    `}</style>
  </Box>
  </Box>

  );
};

export default FeaturesElegant;


